import { render, staticRenderFns } from "./yinlian.vue?vue&type=template&id=47290d26&scoped=true"
import script from "./yinlian.vue?vue&type=script&lang=js"
export * from "./yinlian.vue?vue&type=script&lang=js"
import style0 from "./yinlian.vue?vue&type=style&index=0&id=47290d26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47290d26",
  null
  
)

export default component.exports